import { apiBase } from '@/api/instance';
import Qs from 'qs';

export const SearchFeedPost = (params) => {
  return apiBase({
    url: `/feeds`,
    method: 'get',
    params: params,
    paramsSerializer: (params) => {
      return Qs.stringify(params, { arrayFormat: 'repeat' });
    }
  });
};

export const StoreFeedPost = (params) => {
  return apiBase({
    url: '/feeds',
    method: 'post',
    data: params
  });
};

export const ShowFeedPost = ({ id }) => {
  return apiBase({
    url: `/feeds/${id}`,
    method: 'get'
  });
};

export const UpdateFeedPost = (params) => {
  return apiBase({
    url: `/feeds/${params.id}`,
    method: 'put',
    data: params
  });
};

export const DestroyFeedPost = ({ id }) => {
  return apiBase({
    url: `/feeds/${id}`,
    method: 'delete'
  });
};
